import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import classes from './Modal.module.scss';

const BackDrop = ({ onClose, isClosing }) => {
  return (
    <div
      className={`${classes.backdrop} ${isClosing ? classes.close : ''}`}
      onClick={onClose}
    ></div>
  );
};

const portalElement = document.getElementById('overlays');

const Modal = ({ onClose, isClosing, children }) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <BackDrop onClose={onClose} isClosing={isClosing} />,
        portalElement
      )}
      {ReactDOM.createPortal(children, portalElement)}
    </Fragment>
  );
};

export default Modal;
